import FormationProxy from '@/proxies/Formation';
import * as types from './mutation-types';

export default {
  async create({ commit, dispatch }, payload) {
    try {
      commit(types.LOADING, true);
      const proxy = new FormationProxy();
      await proxy.create(payload);
      await dispatch('refresh');
      dispatch('notification/success', 'confirmationmessage.formation_created', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_add_formation', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },

  async deleteItem({ commit, dispatch }, payload) {
    try {
      commit(types.LOADING, true);
      const proxy = new FormationProxy();
      await proxy.delete(payload);
      await dispatch('refresh');
      dispatch('notification/success', 'confirmationmessage.formation_deleted', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_delete_formation', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },

  async getItems({ commit, dispatch }) {
    try {
      commit(types.LOADING, true);
      const proxy = new FormationProxy();
      const { formations, total } = await proxy.getItems();
      commit(types.SET_ITEMS, formations.map(el => ({
        ...el,
        id: el._id,
        name: el.formation_name,
      })));
      commit(types.TOTAL, total);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_formations', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },

  async refresh({ dispatch }) {
    await dispatch('getItems');
  },

  setSearchFilter({ commit }, payload) {
    commit(types.SET_SEARCH_FILTER, payload);
  },

  async update({ commit, dispatch }, payload) {
    try {
      const { id, ...options } = payload;
      commit(types.LOADING, true);
      const proxy = new FormationProxy();
      await proxy.update(id, options);
      await dispatch('refresh');
      dispatch('notification/success', 'confirmationmessage.formation_updated', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_update_formation', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
};
